module.exports = __webpack_public_path__ + "static/media/logo.80ae337a.png";